{
  "INBOX_MGMT": {
    "HEADER": "받은 편지함",
    "DESCRIPTION": "채널은 고객이 귀하와 상호작용하기 위해 선택하는 커뮤니케이션 방식입니다. 받은 메시지함은 특정 채널에 대한 상호작용을 관리하는 곳입니다. 이메일, 라이브 채팅, 소셜 미디어 등 다양한 소스의 커뮤니케이션을 포함할 수 있습니다.",
    "LEARN_MORE": "받은 메시지함에 대해 자세히 알아보기",
    "COUNT": "{n}개의 받은 메시지함 | {n}개의 받은 메시지함",
    "SEARCH_PLACEHOLDER": "받은 메시지함 검색...",
    "NO_RESULTS": "검색과 일치하는 받은 메시지함이 없습니다",
    "RECONNECTION_REQUIRED": "받은 메시지함의 연결이 끊어졌습니다. 재인증하기 전까지 새 메시지를 받을 수 없습니다.",
    "CLICK_TO_RECONNECT": "다시 연결하려면 여기를 클릭하십시오.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "WhatsApp Business 등록이 완료되지 않았습니다. 다시 연결하기 전에 Meta Business Manager에서 표시 이름 상태를 확인하십시오.",
    "COMPLETE_REGISTRATION": "등록 완료",
    "LIST": {
      "404": "이 계정에는 첨부된 받은 메시지함이 없습니다."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "채널 선택",
        "BODY": "Chatwoot와 통합할 공급자를 선택하십시오."
      },
      "INBOX": {
        "TITLE": "받은 메시지함 만들기",
        "BODY": "계정을 인증하고 받은 메시지함을 만드십시오."
      },
      "AGENT": {
        "TITLE": "에이전트 추가",
        "BODY": "생성된 받은 메시지함에 에이전트를 추가하십시오."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "준비가 완료되었습니다."
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "받은 메시지함 이름",
        "PLACEHOLDER": "받은 메시지함 이름을 입력하십시오 (예: Acme Inc)",
        "ERROR": "올바른 받은 메시지함 이름을 입력하십시오."
      },
      "WEBSITE_NAME": {
        "LABEL": "웹사이트 이름",
        "PLACEHOLDER": "웹사이트 이름 입력 (예: Acme Inc)"
      },
      "FB": {
        "HELP": "추신: 로그인을 함으로써, 우리는 오직 당신의 페이지의 메시지에 접근할 수 있습니다. 당신의 개인 메시지에 Chatwoot는 절대 접근할 수 없습니다.",
        "CHOOSE_PAGE": "페이지 선택",
        "CHOOSE_PLACEHOLDER": "목록에서 페이지 선택",
        "INBOX_NAME": "받은 메시지함 이름",
        "ADD_NAME": "받은 메시지함의 이름 추가",
        "PICK_NAME": "받은 메시지함의 이름을 선택하십시오",
        "PICK_A_VALUE": "값 선택",
        "CREATE_INBOX": "받은 메시지함 만들기"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Instagram으로 계속하기",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Instagram 프로필 연결",
        "HELP": "Instagram 프로필을 채널로 추가하려면 'Instagram으로 계속하기'를 클릭하여 Instagram 프로필을 인증해야 합니다.",
        "ERROR_MESSAGE": "Instagram에 연결하는 동안 오류가 발생했습니다. 다시 시도하십시오.",
        "ERROR_AUTH": "Instagram에 연결하는 동안 오류가 발생했습니다. 다시 시도하십시오.",
        "NEW_INBOX_SUGGESTION": "이 Instagram 계정은 이전에 다른 받은 메시지함에 연결되어 있었으며 현재 이곳으로 마이그레이션되었습니다. 모든 새 메시지가 여기에 표시됩니다. 이전 받은 메시지함에서는 더 이상 이 계정의 메시지를 보내거나 받을 수 없습니다.",
        "DUPLICATE_INBOX_BANNER": "이 Instagram 계정은 새로운 Instagram 채널 받은 메시지함으로 마이그레이션되었습니다. 이 받은 메시지함에서는 더 이상 Instagram 메시지를 보내거나 받을 수 없습니다."
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "TikTok으로 계속하기",
        "CONNECT_YOUR_TIKTOK_PROFILE": "TikTok 프로필 연결",
        "HELP": "TikTok 프로필을 채널로 추가하려면 'TikTok으로 계속하기'를 클릭하여 TikTok 프로필을 인증해야 합니다.",
        "ERROR_MESSAGE": "TikTok에 연결하는 동안 오류가 발생했습니다. 다시 시도하십시오.",
        "ERROR_AUTH": "TikTok에 연결하는 동안 오류가 발생했습니다. 다시 시도하십시오."
      },
      "TWITTER": {
        "HELP": "트위터 프로필을 채널로 추가하려면 '트위터로 로그인'을 클릭하여 트위터 프로필을 인증해야 합니다.",
        "ERROR_MESSAGE": "트위터에 연결하는 동안 오류가 발생했습니다. 다시 시도하십시오.",
        "TWEETS": {
          "ENABLE": "멘션된 트윗에서 대화 만들기"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "웹사이트 채널",
        "DESC": "웹사이트를 위한 채널을 만들고 웹사이트 위젯을 통해 고객 지원을 시작하십시오.",
        "LOADING_MESSAGE": "웹사이트 지원 채널 만들기",
        "CHANNEL_AVATAR": {
          "LABEL": "채널 아바타"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "웹훅 URL",
          "PLACEHOLDER": "웹훅 URL을 입력하십시오.",
          "ERROR": "올바른 URL을 입력하십시오."
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "시크릿을 클립보드에 복사",
          "COPY_SUCCESS": "시크릿이 클립보드에 복사되었습니다",
          "TOGGLE": "시크릿 표시 전환",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "웹사이트 도메인",
          "PLACEHOLDER": "웹사이트 도메인을 입력하십시오 (예: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "헤드라인 입력",
          "PLACEHOLDER": "안녕하세요!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "태그라인 입력",
          "PLACEHOLDER": "우리는 간단하게 우리와 연결되도록 합니다. 우리에게 무엇이든 물어보거나 피드백을 공유하십시오."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "채널 인사말 메시지",
          "PLACEHOLDER": "Acme Inc. 는 일반적으로 몇 시간 후에 회신합니다."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "채널 인사말 사용",
          "HELP_TEXT": "고객이 대화를 시작하고 첫 메시지를 보낼 때 인사말 메시지를 자동으로 전송합니다.",
          "ENABLED": "사용함",
          "DISABLED": "사용 안 함"
        },
        "REPLY_TIME": {
          "TITLE": "응답 시간 설정",
          "IN_A_FEW_MINUTES": "몇 분 후에",
          "IN_A_FEW_HOURS": "몇 시간 안에",
          "IN_A_DAY": "며칠 안에",
          "HELP_TEXT": "이 응답 시간은 라이브 채팅 위젯에 표시됩니다."
        },
        "WIDGET_COLOR": {
          "LABEL": "위젯 색깔",
          "PLACEHOLDER": "위젯에 사용된 위젯 색상 업데이트"
        },
        "SUBMIT_BUTTON": "받은 메시지함 만들기",
        "API": {
          "ERROR_MESSAGE": "웹사이트 채널을 만들 수 없습니다. 다시 시도하십시오."
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp 채널",
        "DESC": "Twilio를 통합하여 SMS 또는 WhatsApp으로 고객 지원을 시작하십시오.",
        "ACCOUNT_SID": {
          "LABEL": "계정 SID",
          "PLACEHOLDER": "Twilio 계정 SID를 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "API_KEY": {
          "USE_API_KEY": "API Key 인증 사용",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "API Key SID를 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "API Key Secret을 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "메시징 서비스 SID",
          "PLACEHOLDER": "Twilio Messaging Service SID를 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다.",
          "USE_MESSAGING_SERVICE": "Twilio Messaging Service 사용"
        },
        "CHANNEL_TYPE": {
          "LABEL": "채널 유형",
          "ERROR": "채널 유형을 선택하십시오."
        },
        "AUTH_TOKEN": {
          "LABEL": "인증 토큰",
          "PLACEHOLDER": "Twilio Auth 토큰을 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "CHANNEL_NAME": {
          "LABEL": "받은 메시지함 이름",
          "PLACEHOLDER": "받은 메시지함 이름을 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "PHONE_NUMBER": {
          "LABEL": "전화 번호",
          "PLACEHOLDER": "메시지를 보낼 전화 번호를 입력하십시오.",
          "ERROR": "`+` 기호로 시작하고 공백이 없는 올바른 전화 번호를 입력하십시오."
        },
        "API_CALLBACK": {
          "TITLE": "콜백 URL",
          "SUBTITLE": "여기에 설치된 URL로 Twilio에서 메시지 콜백 URL을 구성해야 합니다."
        },
        "SUBMIT_BUTTON": "Twilio 채널 만들기",
        "API": {
          "ERROR_MESSAGE": "Twilio 자격 증명을 인증할 수 없습니다. 다시 시도하십시오."
        }
      },
      "SMS": {
        "TITLE": "SMS 채널",
        "DESC": "SMS를 통해 고객 지원을 시작하십시오.",
        "PROVIDERS": {
          "LABEL": "API 공급자",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth"
        },
        "API": {
          "ERROR_MESSAGE": "SMS 채널을 저장할 수 없습니다."
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "계정 ID",
            "PLACEHOLDER": "Bandwidth 계정 ID를 입력하십시오.",
            "ERROR": "해당 입력란은 필수 입력 사항입니다."
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Bandwidth API Key를 입력하십시오.",
            "ERROR": "해당 입력란은 필수 입력 사항입니다."
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Bandwidth API Secret을 입력하십시오.",
            "ERROR": "해당 입력란은 필수 입력 사항입니다."
          },
          "APPLICATION_ID": {
            "LABEL": "애플리케이션 ID",
            "PLACEHOLDER": "Bandwidth 애플리케이션 ID를 입력하십시오.",
            "ERROR": "해당 입력란은 필수 입력 사항입니다."
          },
          "INBOX_NAME": {
            "LABEL": "받은 메시지함 이름",
            "PLACEHOLDER": "받은 메시지함 이름을 입력하십시오.",
            "ERROR": "해당 입력란은 필수 입력 사항입니다."
          },
          "PHONE_NUMBER": {
            "LABEL": "전화 번호",
            "PLACEHOLDER": "메시지를 보낼 전화 번호를 입력하십시오.",
            "ERROR": "`+` 기호로 시작하고 공백이 없는 올바른 전화 번호를 입력하십시오."
          },
          "SUBMIT_BUTTON": "Bandwidth 채널 만들기",
          "API": {
            "ERROR_MESSAGE": "Bandwidth 자격 증명을 인증할 수 없습니다. 다시 시도하십시오."
          },
          "API_CALLBACK": {
            "TITLE": "콜백 URL",
            "SUBTITLE": "여기에 표시된 URL로 Bandwidth에서 메시지 콜백 URL을 구성해야 합니다."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "WhatsApp 채널",
        "DESC": "WhatsApp을 통해 고객 지원을 시작하십시오.",
        "PROVIDERS": {
          "LABEL": "API 공급자",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "Meta를 통한 빠른 설정",
          "TWILIO_DESC": "Twilio 자격 증명으로 연결",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "API 공급자를 선택하십시오",
          "DESCRIPTION": "WhatsApp 공급자를 선택하십시오. Meta를 통해 설정 없이 직접 연결하거나, Twilio 계정 자격 증명을 사용하여 연결할 수 있습니다."
        },
        "INBOX_NAME": {
          "LABEL": "받은 메시지함 이름",
          "PLACEHOLDER": "받은 메시지함 이름을 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "PHONE_NUMBER": {
          "LABEL": "전화 번호",
          "PLACEHOLDER": "메시지를 보낼 전화 번호를 입력하십시오.",
          "ERROR": "`+` 기호로 시작하고 공백이 없는 올바른 전화 번호를 입력하십시오."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "전화 번호 ID",
          "PLACEHOLDER": "Facebook 개발자 대시보드에서 받은 전화 번호 ID를 입력하십시오.",
          "ERROR": "올바른 값을 입력하십시오."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "비즈니스 계정 ID",
          "PLACEHOLDER": "Facebook 개발자 대시보드에서 받은 비즈니스 계정 ID를 입력하십시오.",
          "ERROR": "올바른 값을 입력하십시오."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "웹훅 인증 토큰",
          "PLACEHOLDER": "Facebook 웹훅에 구성할 인증 토큰을 입력하십시오.",
          "ERROR": "올바른 값을 입력하십시오."
        },
        "API_KEY": {
          "LABEL": "API key",
          "SUBTITLE": "WhatsApp API key를 구성하십시오.",
          "PLACEHOLDER": "API key",
          "ERROR": "올바른 값을 입력하십시오."
        },
        "API_CALLBACK": {
          "TITLE": "콜백 URL",
          "SUBTITLE": "아래에 표시된 값으로 Facebook 개발자 포털에서 웹훅 URL과 인증 토큰을 구성해야 합니다.",
          "WEBHOOK_URL": "웹훅 URL",
          "WEBHOOK_VERIFICATION_TOKEN": "웹훅 인증 토큰"
        },
        "SUBMIT_BUTTON": "WhatsApp 채널 만들기",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Meta를 통한 빠른 설정",
          "DESC": "WhatsApp 임베디드 가입 플로우를 사용하여 새 번호를 빠르게 연결하십시오. Meta로 리디렉션되어 WhatsApp Business 계정에 로그인하게 됩니다. 관리자 액세스 권한이 있으면 설정이 원활하고 쉽게 진행됩니다.",
          "BENEFITS": {
            "TITLE": "임베디드 가입의 장점:",
            "EASY_SETUP": "수동 구성이 필요 없습니다",
            "SECURE_AUTH": "안전한 OAuth 기반 인증",
            "AUTO_CONFIG": "자동 웹훅 및 전화 번호 구성"
          },
          "LEARN_MORE": {
            "TEXT": "통합 가입, 요금 및 제한 사항에 대해 자세히 알아보려면 {link}을 방문하십시오.",
            "LINK_TEXT": "이 링크"
          },
          "SUBMIT_BUTTON": "WhatsApp Business에 연결",
          "AUTH_PROCESSING": "Meta로 인증 중",
          "WAITING_FOR_BUSINESS_INFO": "Meta 창에서 비즈니스 설정을 완료하십시오...",
          "PROCESSING": "WhatsApp Business 계정을 설정하는 중",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Facebook SDK를 로드하는 중...",
          "CANCELLED": "WhatsApp 가입이 취소되었습니다",
          "SUCCESS_TITLE": "WhatsApp Business 계정이 연결되었습니다!",
          "WAITING_FOR_AUTH": "인증 대기 중...",
          "INVALID_BUSINESS_DATA": "Facebook에서 잘못된 비즈니스 데이터를 수신했습니다. 다시 시도하십시오.",
          "SIGNUP_ERROR": "가입 오류가 발생했습니다",
          "AUTH_NOT_COMPLETED": "인증이 완료되지 않았습니다. 프로세스를 다시 시작하십시오.",
          "SUCCESS_FALLBACK": "WhatsApp Business 계정이 성공적으로 구성되었습니다",
          "MANUAL_FALLBACK": "번호가 이미 WhatsApp Business Platform (API)에 연결되어 있거나, 자체 번호를 온보딩하는 기술 공급자인 경우 {link}을 사용하십시오",
          "MANUAL_LINK_TEXT": "수동 설정 플로우",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "WhatsApp 채널을 저장할 수 없습니다."
        }
      },
      "VOICE": {
        "TITLE": "음성 채널",
        "DESC": "Twilio Voice를 통합하여 전화 통화로 고객 지원을 시작하십시오.",
        "PHONE_NUMBER": {
          "LABEL": "전화 번호",
          "PLACEHOLDER": "전화 번호를 입력하십시오 (예: +1234567890)",
          "ERROR": "E.164 형식의 올바른 전화 번호를 입력하십시오 (예: +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "계정 SID",
            "PLACEHOLDER": "Twilio 계정 SID를 입력하십시오.",
            "REQUIRED": "계정 SID는 필수입니다."
          },
          "AUTH_TOKEN": {
            "LABEL": "인증 토큰",
            "PLACEHOLDER": "Twilio 인증 토큰을 입력하십시오.",
            "REQUIRED": "인증 토큰은 필수입니다."
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "Twilio API Key SID를 입력하십시오.",
            "REQUIRED": "API Key SID는 필수입니다."
          },
          "API_KEY_SECRET": {
            "LABEL": "API Key Secret",
            "PLACEHOLDER": "Twilio API Key Secret을 입력하십시오.",
            "REQUIRED": "API Key Secret은 필수입니다."
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio 음성 URL",
          "TWILIO_VOICE_URL_SUBTITLE": "이 URL을 Twilio 전화 번호 및 TwiML 앱의 음성 URL로 구성하십시오.",
          "TWILIO_STATUS_URL_TITLE": "Twilio 상태 콜백 URL",
          "TWILIO_STATUS_URL_SUBTITLE": "이 URL을 Twilio 전화 번호의 상태 콜백 URL로 구성하십시오."
        },
        "SUBMIT_BUTTON": "음성 채널 만들기",
        "API": {
          "ERROR_MESSAGE": "음성 채널을 만들 수 없습니다."
        }
      },
      "API_CHANNEL": {
        "TITLE": "API 채널",
        "DESC": "API 채널과 통합하여 고객 지원을 시작하십시오.",
        "CHANNEL_NAME": {
          "LABEL": "채널 이름",
          "PLACEHOLDER": "채널 이름을 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "WEBHOOK_URL": {
          "LABEL": "웹훅 URL",
          "SUBTITLE": "이벤트 콜백을 받을 URL을 구성하십시오.",
          "PLACEHOLDER": "웹훅 URL"
        },
        "SUBMIT_BUTTON": "API 채널 만들기",
        "API": {
          "ERROR_MESSAGE": "API 채널을 저장할 수 없습니다."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "이메일 채널",
        "DESC": "이메일 받은 메시지함을 통합하십시오.",
        "CHANNEL_NAME": {
          "LABEL": "채널 이름",
          "PLACEHOLDER": "채널 이름을 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "EMAIL": {
          "LABEL": "이메일",
          "SUBTITLE": "고객이 지원 요청을 보내는 이메일 주소를 입력하십시오.",
          "PLACEHOLDER": "이메일"
        },
        "SUBMIT_BUTTON": "이메일 채널 만들기",
        "API": {
          "ERROR_MESSAGE": "이메일 채널을 저장할 수 없습니다."
        },
        "FINISH_MESSAGE": "이메일 받은 메시지함이 성공적으로 생성되었습니다! 아래 주소로 이메일 전달을 시작하거나, SMTP 및 IMAP 자격 증명을 구성하여 이메일을 직접 보내고 받을 수 있습니다.",
        "FINISH_MESSAGE_NO_FORWARDING": "이메일 받은 메시지함이 성공적으로 생성되었습니다! 이메일을 보내고 받으려면 SMTP 및 IMAP 자격 증명을 구성해야 합니다. 이 설정이 없으면 이메일이 처리되지 않습니다.",
        "FORWARDING_ADDRESS_LABEL": "이 주소로 이메일 전달:",
        "CONFIGURE_SMTP_IMAP_LINK": "여기를 클릭하세요",
        "CONFIGURE_SMTP_IMAP_TEXT": " IMAP 및 SMTP 설정을 구성하십시오"
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE 채널",
        "DESC": "LINE 채널과 통합하여 고객 지원을 시작하십시오.",
        "CHANNEL_NAME": {
          "LABEL": "채널 이름",
          "PLACEHOLDER": "채널 이름을 입력하십시오.",
          "ERROR": "해당 입력란은 필수 입력 사항입니다."
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE 채널 ID",
          "PLACEHOLDER": "LINE 채널 ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE 채널 Secret",
          "PLACEHOLDER": "LINE 채널 Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE 채널 Token",
          "PLACEHOLDER": "LINE 채널 Token"
        },
        "SUBMIT_BUTTON": "LINE 채널 만들기",
        "API": {
          "ERROR_MESSAGE": "LINE 채널을 저장할 수 없습니다."
        },
        "API_CALLBACK": {
          "TITLE": "콜백 URL",
          "SUBTITLE": "여기에 표시된 URL로 LINE 애플리케이션에서 웹훅 URL을 구성해야 합니다."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram 채널",
        "DESC": "Telegram 채널과 통합하여 고객 지원을 시작하십시오.",
        "BOT_TOKEN": {
          "LABEL": "봇 토큰",
          "SUBTITLE": "Telegram BotFather에서 받은 봇 토큰을 구성하십시오.",
          "PLACEHOLDER": "봇 토큰"
        },
        "SUBMIT_BUTTON": "Telegram 채널 만들기",
        "API": {
          "ERROR_MESSAGE": "Telegram 채널을 저장할 수 없습니다."
        }
      },
      "AUTH": {
        "TITLE": "채널 선택",
        "DESC": "Chatwoot는 라이브 채팅 위젯, Facebook Messenger, WhatsApp, 이메일 등을 채널로 지원합니다. 사용자 정의 채널을 만들려면 API 채널을 사용하여 만들 수 있습니다. 시작하려면 아래에서 채널을 선택하십시오.",
        "TITLE_NEXT": "설정 완료",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "웹사이트",
            "DESCRIPTION": "라이브 채팅 위젯 만들기"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Facebook 페이지 연결"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "WhatsApp으로 고객 지원"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "이메일",
            "DESCRIPTION": "Gmail, Outlook 또는 기타 공급자와 연결"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Twilio 또는 Bandwidth로 SMS 채널 통합"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "API를 사용하여 사용자 정의 채널 만들기"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "봇 토큰을 사용하여 Telegram 채널 구성"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Line 채널 통합"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Instagram 계정 연결"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "TikTok 계정 연결"
          },
          "VOICE": {
            "TITLE": "음성",
            "DESCRIPTION": "Twilio Voice와 통합"
          }
        }
      },
      "AGENTS": {
        "TITLE": "에이전트",
        "DESC": "여기서 에이전트를 추가하여 새로 만든 받은 메시지함을 관리할 수 있습니다. 선택된 에이전트만 받은 메시지함에 액세스할 수 있습니다. 해당 받은 메시지함에 선택되지 않은 에이전트는 메시지를 보거나 응답할 수 없습니다. <br> <b>추신:</b> 관리자로서 모든 받은 메시지함에 대한 액세스 권한이 필요한 경우, 자신이 만든 모든 받은 메시지함에 자신을 에이전트로 추가해야 합니다.",
        "VALIDATION_ERROR": "새 받은 메시지함에 에이전트를 한 명 이상 추가하십시오.",
        "PICK_AGENTS": "받은 메시지함에 대한 에이전트 선택"
      },
      "DETAILS": {
        "TITLE": "받은 메시지함 자세히",
        "DESC": "아래 드롭다운에서 Chatwoot에 연결할 Facebook 페이지를 선택하십시오. 더 나은 식별을 위해 받은 메시지함에 사용자 정의 이름을 지정할 수 있습니다."
      },
      "FINISH": {
        "TITLE": "완료되었습니다!",
        "DESC": "Facebook 페이지를 Chatwoot와 성공적으로 통합하셨습니다. 다음부터 고객이 페이지에 메시지를 보낼 때, 대화는 받은 메시지함에 자동으로 나타납니다.<br>웹사이트에 쉽게 추가할 수 있는 위젯 스크립트도 제공하고 있습니다. 일단 당신의 웹사이트에 생방송으로 접속하면, 고객들은 어떠한 외부 도구의 도움 없이도 당신의 웹사이트에서 바로 당신에게 메시지를 보낼 수 있고, 대화는 바로 여기 Chatwoot에 나타납니다.<br>멋지죠? 음, 우리는 그럴려고 노력합니다 :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "이메일 공급자를 선택하십시오",
        "DESCRIPTION": "아래 목록에서 이메일 공급자를 선택하십시오. 목록에 이메일 공급자가 없는 경우, 기타 공급자 옵션을 선택하고 IMAP 및 SMTP 자격 증명을 입력하십시오."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft 이메일",
        "DESCRIPTION": "시작하려면 Microsoft로 로그인 버튼을 클릭하십시오. 이메일 로그인 페이지로 리디렉션됩니다. 요청된 권한을 수락하면 받은 메시지함 생성 단계로 다시 리디렉션됩니다.",
        "EMAIL_PLACEHOLDER": "이메일 주소 입력",
        "SIGN_IN": "Microsoft로 로그인",
        "ERROR_MESSAGE": "Microsoft에 연결하는 동안 오류가 발생했습니다. 다시 시도하십시오."
      },
      "GOOGLE": {
        "TITLE": "Google 이메일",
        "DESCRIPTION": "시작하려면 Google로 로그인 버튼을 클릭하십시오. 이메일 로그인 페이지로 리디렉션됩니다. 요청된 권한을 수락하면 받은 메시지함 생성 단계로 다시 리디렉션됩니다.",
        "SIGN_IN": "Google로 로그인",
        "EMAIL_PLACEHOLDER": "이메일 주소 입력",
        "ERROR_MESSAGE": "Google에 연결하는 동안 오류가 발생했습니다. 다시 시도하십시오."
      }
    },
    "DETAILS": {
      "LOADING_FB": "Facebook 인증하는 중...",
      "ERROR_FB_LOADING": "Facebook SDK 로드 오류. 광고 차단기를 비활성화하고 다른 브라우저에서 다시 시도하십시오.",
      "ERROR_FB_AUTH": "문제가 발생했습니다. 페이지를 새로 고치십시오...",
      "ERROR_FB_UNAUTHORIZED": "이 작업을 수행할 권한이 없습니다.",
      "ERROR_FB_UNAUTHORIZED_HELP": "전체 제어 권한으로 Facebook 페이지에 액세스할 수 있는지 확인하십시오. Facebook 역할에 대한 자세한 내용은 <a href=\" https://www.facebook.com/help/187316341316631\">여기</a>에서 확인할 수 있습니다.",
      "CREATING_CHANNEL": "받은 메시지함을 만드는 중...",
      "TITLE": "받은 메시지함 세부 구성",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "에이전트 추가",
      "ADD_AGENTS": "받은 메시지함에 에이전트를 추가하는 중..."
    },
    "FINISH": {
      "TITLE": "받은 메시지함이 준비되었습니다!",
      "MESSAGE": "이제 새로운 채널을 통해 고객과 대화할 수 있습니다. 즐거운 지원 되십시오",
      "BUTTON_TEXT": "이동하기",
      "MORE_SETTINGS": "추가 설정",
      "WEBSITE_SUCCESS": "웹사이트 채널 만들기를 완료하셨습니다. 아래 표시된 코드를 복사하여 웹사이트에 붙여 넣으십시오. 다음에 고객이 라이브 채팅을 사용할 때 대화는 받은 메시지함에 자동으로 표시됩니다.",
      "WHATSAPP_QR_INSTRUCTION": "위의 QR 코드를 스캔하여 WhatsApp 받은 메시지함을 빠르게 테스트하십시오",
      "MESSENGER_QR_INSTRUCTION": "위의 QR 코드를 스캔하여 Facebook Messenger 받은 메시지함을 빠르게 테스트하십시오",
      "TELEGRAM_QR_INSTRUCTION": "위의 QR 코드를 스캔하여 Telegram 받은 메시지함을 빠르게 테스트하십시오"
    },
    "REAUTH": "재승인",
    "VIEW": "보기",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "받은 메시지함 설정이 성공적으로 업데이트되었습니다.",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "자동 할당이 성공적으로 업데이트되었습니다.",
        "ERROR_MESSAGE": "받은 메시지함 설정을 업데이트할 수 없습니다. 나중에 다시 시도하십시오."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "사용함",
        "DISABLED": "사용 안 함"
      },
      "ENABLE_CSAT": {
        "ENABLED": "사용함",
        "DISABLED": "사용 안 함"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "발신자 이름",
        "SUB_TEXT": "에이전트로부터 이메일을 받을 때 고객에게 표시되는 이름을 선택하십시오.",
        "FOR_EG": "예시:",
        "FRIENDLY": {
          "TITLE": "친근한",
          "FROM": "에서",
          "SUBTITLE": "발신자 이름에 답장을 보낸 에이전트의 이름을 추가하여 친근하게 만드십시오."
        },
        "PROFESSIONAL": {
          "TITLE": "전문적인",
          "SUBTITLE": "이메일 헤더에서 구성된 비즈니스 이름만 발신자 이름으로 사용합니다."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ 비즈니스 이름 구성",
          "PLACEHOLDER": "비즈니스 이름을 입력하십시오.",
          "SAVE_BUTTON_TEXT": "저장"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "사용함",
        "DISABLED": "사용 안 함"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "사용함",
        "DISABLED": "사용 안 함"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "같은 대화 다시 열기",
        "DISABLED": "새 대화 만들기",
        "ENABLED_DESCRIPTION": "연락처가 다시 메시지를 보내면 이전 대화가 다시 열립니다.",
        "DISABLED_DESCRIPTION": "이전 대화가 해결된 후에는 매번 새 대화가 생성됩니다."
      },
      "ENABLE_HMAC": {
        "LABEL": "사용"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "삭제",
      "AVATAR_DELETE_BUTTON_TEXT": "아바타 삭제",
      "CONFIRM": {
        "TITLE": "삭제 확인",
        "MESSAGE": "삭제하시겠습니까? ",
        "PLACE_HOLDER": "확인하려면 {inboxName}을 입력하십시오.",
        "YES": "예, 삭제합니다. ",
        "NO": "아니요, 유지합니다. "
      },
      "API": {
        "SUCCESS_MESSAGE": "받은 메시지함이 성공적으로 삭제되었습니다.",
        "ERROR_MESSAGE": "받은 메시지함을 삭제할 수 없습니다. 나중에 다시 시도하십시오.",
        "AVATAR_SUCCESS_MESSAGE": "받은 메시지함 아바타가 성공적으로 삭제되었습니다.",
        "AVATAR_ERROR_MESSAGE": "받은 메시지함 아바타를 삭제할 수 없습니다. 나중에 다시 시도하십시오."
      }
    },
    "TABS": {
      "SETTINGS": "설정",
      "COLLABORATORS": "협력자",
      "CONFIGURATION": "구성",
      "CAMPAIGN": "캠페인",
      "PRE_CHAT_FORM": "대화 전 설문",
      "BUSINESS_HOURS": "영업시간",
      "WIDGET_BUILDER": "위젯 빌더",
      "BOT_CONFIGURATION": "봇 구성",
      "ACCOUNT_HEALTH": "계정 상태",
      "CSAT": "CSAT",
      "VOICE": "음성",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "채널 환경설정",
    "WIDGET_FEATURES": "위젯 기능",
    "ACCOUNT_HEALTH": {
      "TITLE": "WhatsApp 계정 관리",
      "DESCRIPTION": "WhatsApp 계정 상태, 메시지 제한 및 품질을 검토하십시오. 필요한 경우 설정을 업데이트하거나 문제를 해결하십시오.",
      "GO_TO_SETTINGS": "Meta Business Manager로 이동",
      "NO_DATA": "상태 데이터를 사용할 수 없습니다",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "표시 전화 번호",
          "TOOLTIP": "고객에게 표시되는 전화 번호"
        },
        "VERIFIED_NAME": {
          "LABEL": "비즈니스 이름",
          "TOOLTIP": "WhatsApp에서 인증된 비즈니스 이름"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "표시 이름 상태",
          "TOOLTIP": "비즈니스 이름 인증 상태"
        },
        "QUALITY_RATING": {
          "LABEL": "품질 등급",
          "TOOLTIP": "계정의 WhatsApp 품질 등급"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "메시지 제한 등급",
          "TOOLTIP": "계정의 일일 메시지 제한"
        },
        "ACCOUNT_MODE": {
          "LABEL": "계정 모드",
          "TOOLTIP": "WhatsApp 계정의 현재 운영 모드"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "24시간당 고객 250명",
          "TIER_1000": "24시간당 고객 1,000명",
          "TIER_1K": "24시간당 고객 1,000명",
          "TIER_10K": "24시간당 고객 10,000명",
          "TIER_100K": "24시간당 고객 100,000명",
          "TIER_UNLIMITED": "24시간당 무제한 고객",
          "UNKNOWN": "등급을 사용할 수 없습니다"
        },
        "STATUSES": {
          "APPROVED": "승인됨",
          "PENDING_REVIEW": "검토 대기 중",
          "AVAILABLE_WITHOUT_REVIEW": "검토 없이 사용 가능",
          "REJECTED": "거부됨",
          "DECLINED": "거절됨",
          "NON_EXISTS": "존재하지 않음"
        },
        "MODES": {
          "SANDBOX": "샌드박스",
          "LIVE": "라이브"
        }
      },
      "WEBHOOK": {
        "TITLE": "웹훅 구성",
        "DESCRIPTION": "고객 메시지를 수신하려면 WhatsApp Business 계정에 웹훅 URL이 필요합니다",
        "ACTION_REQUIRED": "웹훅이 구성되지 않았습니다",
        "REGISTER_BUTTON": "웹훅 등록",
        "REGISTER_SUCCESS": "웹훅이 성공적으로 등록되었습니다",
        "REGISTER_ERROR": "웹훅 등록에 실패했습니다. 다시 시도하십시오.",
        "CONFIGURED_SUCCESS": "웹훅이 성공적으로 구성되었습니다",
        "URL_MISMATCH": "웹훅 URL이 일치하지 않습니다"
      }
    },
    "SETTINGS": "설정",
    "FEATURES": {
      "LABEL": "기능",
      "DISPLAY_FILE_PICKER": "위젯에 파일 선택기 표시",
      "DISPLAY_EMOJI_PICKER": "위젯에 이모지 선택기 표시",
      "ALLOW_END_CONVERSATION": "사용자가 위젯에서 대화를 종료할 수 있도록 허용",
      "USE_INBOX_AVATAR_FOR_BOT": "봇에 받은 메시지함 이름 및 아바타 사용"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "메신저 스크립트",
      "MESSENGER_SUB_HEAD": "이 버튼을 body 태그 안에 넣으십시오.",
      "ALLOWED_DOMAINS": {
        "TITLE": "허용된 도메인",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "비밀 키",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "에이전트",
      "INBOX_AGENTS_SUB_TEXT": "받은 메시지함에서 에이전트 추가 또는 제거",
      "AGENT_ASSIGNMENT": "대화 할당",
      "AGENT_ASSIGNMENT_SUB_TEXT": "대화 할당 설정 업데이트",
      "UPDATE": "업데이트",
      "ENABLE_EMAIL_COLLECT_BOX": "이메일 수집 박스 사용",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "새 대화에서 이메일 수집 박스 사용 또는 사용 안 함",
      "AUTO_ASSIGNMENT": "자동 할당 사용",
      "SENDER_NAME_SECTION": "이메일에 에이전트 이름 표시",
      "SENDER_NAME_SECTION_TEXT": "이메일에 에이전트 이름 표시를 사용 또는 사용 안 함으로 설정합니다. 사용 안 함 시 비즈니스 이름이 표시됩니다.",
      "ENABLE_CONTINUITY_VIA_EMAIL": "이메일을 통한 대화 연속성 사용",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "연락처 이메일 주소가 있는 경우 이메일을 통해 대화가 계속됩니다.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "단일 대화로 제한",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "이 받은 메시지함에서 동일한 연락처에 대한 다중 대화를 사용 또는 사용 안 함으로 설정",
      "INBOX_UPDATE_TITLE": "받은 메시지함 설정",
      "INBOX_UPDATE_SUB_TEXT": "받은 메시지함 설정 업데이트",
      "AUTO_ASSIGNMENT_SUB_TEXT": "받은 메시지함에 추가된 에이전트에 새 대화를 자동으로 할당하거나 할당하지 않도록 설정하십시오.",
      "HMAC_VERIFICATION": "사용자 신원 검증",
      "HMAC_DESCRIPTION": "이 키를 사용하여 사용자의 신원을 확인하는 데 사용할 수 있는 비밀 토큰을 생성할 수 있습니다.",
      "HMAC_LINK_TO_DOCS": "자세한 내용은 여기에서 확인할 수 있습니다.",
      "HMAC_MANDATORY_VERIFICATION": "사용자 신원 검증 강제 적용",
      "HMAC_MANDATORY_DESCRIPTION": "사용 시, 검증할 수 없는 요청은 거부됩니다.",
      "INBOX_IDENTIFIER": "받은 메시지함 식별자",
      "INBOX_IDENTIFIER_SUB_TEXT": "여기에 표시된 `inbox_identifier` 토큰을 사용하여 API 클라이언트를 인증하십시오.",
      "FORWARD_EMAIL_TITLE": "이메일 전달",
      "FORWARD_EMAIL_SUB_TEXT": "다음 이메일 주소로 이메일 전달을 시작하십시오.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "이 설치에서 받은 메시지함으로의 이메일 전달이 현재 비활성화되어 있습니다. 이 기능을 사용하려면 관리자가 활성화해야 합니다. 관리자에게 문의하십시오.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "대화 해결 후 메시지 허용",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "대화가 해결된 후에도 최종 사용자가 메시지를 보낼 수 있도록 허용합니다.",
      "WHATSAPP_SECTION_SUBHEADER": "이 API Key는 WhatsApp API와의 통합에 사용됩니다.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "WhatsApp API와의 통합에 사용할 새 API key를 입력하십시오.",
      "WHATSAPP_SECTION_TITLE": "API Key",
      "WHATSAPP_SECTION_UPDATE_TITLE": "API Key 업데이트",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "여기에 새 API Key를 입력하십시오.",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "업데이트",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp 임베디드 가입",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "이 받은 메시지함은 WhatsApp 임베디드 가입을 통해 연결되었습니다.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "이 받은 메시지함을 다시 구성하여 WhatsApp Business 설정을 업데이트할 수 있습니다.",
      "WHATSAPP_RECONFIGURE_BUTTON": "다시 구성",
      "WHATSAPP_CONNECT_TITLE": "WhatsApp Business에 연결",
      "WHATSAPP_CONNECT_SUBHEADER": "더 쉬운 관리를 위해 WhatsApp 임베디드 가입으로 업그레이드하십시오.",
      "WHATSAPP_CONNECT_DESCRIPTION": "향상된 기능과 더 쉬운 관리를 위해 이 받은 메시지함을 WhatsApp Business에 연결하십시오.",
      "WHATSAPP_CONNECT_BUTTON": "연결",
      "WHATSAPP_CONNECT_SUCCESS": "WhatsApp Business에 성공적으로 연결되었습니다!",
      "WHATSAPP_CONNECT_ERROR": "WhatsApp Business에 연결하지 못했습니다. 다시 시도하십시오.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "WhatsApp Business가 성공적으로 다시 구성되었습니다!",
      "WHATSAPP_RECONFIGURE_ERROR": "WhatsApp Business를 다시 구성하지 못했습니다. 다시 시도하십시오.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp 앱 ID가 구성되지 않았습니다. 관리자에게 문의하십시오.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp 구성 ID가 구성되지 않았습니다. 관리자에게 문의하십시오.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp 로그인이 취소되었습니다. 다시 시도하십시오.",
      "WHATSAPP_WEBHOOK_TITLE": "웹훅 인증 토큰",
      "WHATSAPP_WEBHOOK_SUBHEADER": "이 토큰은 웹훅 엔드포인트의 진위를 확인하는 데 사용됩니다.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "템플릿 동기화",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "WhatsApp에서 메시지 템플릿을 수동으로 동기화하여 사용 가능한 템플릿을 업데이트하십시오.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "템플릿 동기화",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "템플릿 동기화가 성공적으로 시작되었습니다. 업데이트되기까지 몇 분 정도 걸릴 수 있습니다.",
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "대화 전 설문 설정 업데이트"
    },
    "HELP_CENTER": {
      "LABEL": "도움말 센터",
      "PLACEHOLDER": "도움말 센터 선택",
      "SELECT_PLACEHOLDER": "도움말 센터 선택",
      "NONE": "없음",
      "REMOVE": "도움말 센터 제거",
      "SUB_TEXT": "받은 메시지함에 도움말 센터 연결"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "자동 할당 제한",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "0보다 큰 값을 입력하십시오.",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "이 받은 메시지함에서 에이전트에게 자동 할당될 수 있는 최대 대화 수를 제한합니다."
    },
    "ASSIGNMENT": {
      "TITLE": "대화 할당",
      "DESCRIPTION": "할당 정책에 따라 수신 대화를 사용 가능한 에이전트에게 자동으로 할당합니다.",
      "ENABLE_AUTO_ASSIGNMENT": "자동 대화 할당 사용",
      "DEFAULT_RULES_TITLE": "기본 할당 규칙",
      "DEFAULT_RULES_DESCRIPTION": "모든 대화에 기본 할당 동작을 사용합니다.",
      "DEFAULT_RULE_1": "가장 먼저 생성된 대화 우선",
      "DEFAULT_RULE_2": "라운드 로빈 배분",
      "CUSTOMIZE_WITH_POLICY": "할당 정책으로 사용자 정의",
      "USING_POLICY": "이 받은 메시지함에 사용자 정의 할당 정책을 사용 중",
      "CUSTOMIZE_POLICY": "할당 정책으로 사용자 정의",
      "DELETE_POLICY": "정책 삭제",
      "POLICY_LABEL": "할당 정책",
      "ASSIGNMENT_ORDER_LABEL": "할당 순서",
      "ASSIGNMENT_METHOD_LABEL": "할당 방법",
      "POLICY_STATUS": {
        "ACTIVE": "활성",
        "INACTIVE": "비활성"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "가장 먼저 생성됨",
        "LONGEST_WAITING": "가장 오래 대기 중"
      },
      "METHOD": {
        "ROUND_ROBIN": "라운드 로빈",
        "BALANCED": "균형 할당"
      },
      "UPGRADE_PROMPT": "사용자 정의 할당 정책은 Business 플랜에서 사용할 수 있습니다.",
      "UPGRADE_TO_BUSINESS": "Business로 업그레이드",
      "DEFAULT_POLICY_LINKED": "기본 정책이 연결됨",
      "DEFAULT_POLICY_DESCRIPTION": "이 받은 메시지함에서 대화가 에이전트에게 할당되는 방식을 사용자 정의하려면 사용자 정의 할당 정책을 연결하십시오.",
      "LINK_EXISTING_POLICY": "기존 정책 연결",
      "CREATE_NEW_POLICY": "새 정책 만들기",
      "NO_POLICIES": "할당 정책을 찾을 수 없습니다.",
      "VIEW_ALL_POLICIES": "모든 정책 보기",
      "CURRENT_BEHAVIOR": "현재 기본 할당 동작을 사용 중:",
      "LINK_SUCCESS": "할당 정책이 성공적으로 연결되었습니다.",
      "LINK_ERROR": "할당 정책을 연결하지 못했습니다."
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "할당 정책을 삭제하시겠습니까?",
      "DELETE_CONFIRM_MESSAGE": "이 받은 메시지함에서 이 할당 정책을 제거하시겠습니까? 받은 메시지함은 기본 할당 규칙으로 돌아갑니다.",
      "CANCEL": "취소",
      "CONFIRM_DELETE": "삭제",
      "DELETE_SUCCESS": "할당 정책이 성공적으로 제거되었습니다.",
      "DELETE_ERROR": "할당 정책을 제거하지 못했습니다."
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "재승인",
      "SUBTITLE": "Facebook 연결이 만료되었습니다. 서비스를 계속하려면 Facebook 페이지를 다시 연결하십시오.",
      "MESSAGE_SUCCESS": "다시 연결 성공",
      "MESSAGE_ERROR": "오류가 발생했습니다. 다시 시도하십시오."
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "대화 전 설문을 통해, 실제 대화 전에 사용자 정보를 확보할 수 있습니다.",
      "SET_FIELDS": "대화 전 설문 필드",
      "SET_FIELDS_HEADER": {
        "FIELDS": "필드",
        "LABEL": "레이블",
        "PLACE_HOLDER": "플레이스홀더",
        "KEY": "키",
        "TYPE": "유형",
        "REQUIRED": "필수"
      },
      "ENABLE": {
        "LABEL": "대화 전 설문 사용하기",
        "OPTIONS": {
          "ENABLED": "예",
          "DISABLED": "아니오"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "대화 전 메시지",
        "PLACEHOLDER": "이 메시지가 대화 전 설문과 함께 사용자에게 보여집니다."
      },
      "REQUIRE_EMAIL": {
        "LABEL": "대화 전 사용자들에게 이름과 이메일 주소를 요구합니다."
      }
    },
    "CSAT": {
      "TITLE": "CSAT 사용",
      "SUBTITLE": "대화가 끝날 때 자동으로 CSAT 설문조사를 발송하여 고객이 지원 경험에 대해 어떻게 느끼는지 파악합니다. 만족도 추이를 추적하고 시간이 지남에 따라 개선할 영역을 식별합니다.",
      "DISPLAY_TYPE": {
        "LABEL": "표시 유형"
      },
      "MESSAGE": {
        "LABEL": "메시지",
        "PLACEHOLDER": "사용자에게 설문과 함께 표시할 메시지를 입력하십시오."
      },
      "BUTTON_TEXT": {
        "LABEL": "버튼 텍스트",
        "PLACEHOLDER": "평가해 주십시오"
      },
      "LANGUAGE": {
        "LABEL": "언어",
        "PLACEHOLDER": "템플릿 언어 선택"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "메시지 미리보기",
        "TOOLTIP": "WhatsApp 플랫폼에서 렌더링될 때 약간 다를 수 있습니다."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "WhatsApp에서 승인됨",
        "PENDING": "WhatsApp 승인 대기 중",
        "REJECTED": "Meta에서 템플릿을 거부했습니다",
        "DEFAULT": "WhatsApp 승인이 필요합니다",
        "NOT_FOUND": "Meta 플랫폼에 해당 템플릿이 존재하지 않습니다."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp 템플릿이 성공적으로 생성되어 승인을 위해 전송되었습니다.",
        "ERROR_MESSAGE": "WhatsApp 템플릿을 생성하지 못했습니다."
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "설문 세부 정보 편집",
        "DESCRIPTION": "이전 템플릿을 삭제하고 WhatsApp 승인을 위해 다시 전송될 새 템플릿을 만듭니다.",
        "CONFIRM": "새 템플릿 만들기",
        "CANCEL": "돌아가기"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "유틸리티 적합성 확인",
        "HELPER_NOTE": "제출 전에 이 메시지를 확인하여 유틸리티 적합성을 높이십시오. 시스템은 보고용 버튼이 포함된 전용 CSAT 템플릿을 만들고 Utility로 제출하지만, Meta는 내용에 따라 이를 Marketing으로 다시 분류할 수 있습니다.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "이는 가이드용 점검이며 Meta 승인을 보장하지 않습니다.",
        "SUGGESTION_LABEL": "추천 유틸리티 안전 문구",
        "APPLY": "이 문구 사용",
        "ERROR_MESSAGE": "메시지를 분석할 수 없습니다. 다시 시도하십시오.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "유틸리티일 가능성 높음",
          "LIKELY_MARKETING": "마케팅일 가능성 높음",
          "UNCLEAR": "추가 확인 필요"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "설문 규칙",
        "DESCRIPTION_PREFIX": "대화가 다음 레이블 중 하나를",
        "DESCRIPTION_SUFFIX": "경우 설문을 전송합니다",
        "OPERATOR": {
          "CONTAINS": "포함하는",
          "DOES_NOT_CONTAINS": "포함하지 않는"
        },
        "SELECT_PLACEHOLDER": "레이블 선택"
      },
      "NOTE": "참고: CSAT 설문조사는 대화당 한 번만 전송됩니다.",
      "WHATSAPP_NOTE": "참고: 템플릿을 생성하여 WhatsApp 승인을 위해 전송합니다. 승인된 후 설문 규칙에 따라 대화당 한 번만 설문조사가 전송됩니다.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT 설정이 성공적으로 업데이트되었습니다.",
        "ERROR_MESSAGE": "CSAT 설정을 업데이트할 수 없습니다. 나중에 다시 시도하십시오."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "영업시간 설정",
      "SUBTITLE": "라이브챗 위젯의 대화용 영업시간을 설정하십시오.",
      "WEEKLY_TITLE": "일주일 중 영업시간 설정",
      "TIMEZONE_LABEL": "표준시간대 선택",
      "UPDATE": "변경된 영업시간 적용",
      "TOGGLE_AVAILABILITY": "이 받은 메시지함에 대해 영업시간 설정 적용",
      "UNAVAILABLE_MESSAGE_LABEL": "방문자에게 표시할 부재 메시지",
      "TOGGLE_HELP": "영업시간 설정을 사용하면 모든 에이전트가 오프라인이더라도 라이브 채팅 위젯에 근무 가능 시간이 표시됩니다. 근무 가능 시간 외에는 방문자에게 메시지와 대화 전 설문으로 안내할 수 있습니다.",
      "DAY": {
        "DAY": "요일",
        "AVAILABILITY": "운영 시간",
        "HOURS": "Hours",
        "ENABLE": "아래 날짜에 대해 영업시간 설정 적용",
        "UNAVAILABLE": "영업 종료",
        "VALIDATION_ERROR": "영업시작 시간은 영업종료 시간보다 빨라야 합니다.",
        "CHOOSE": "선택"
      },
      "ALL_DAY": "종일"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "IMAP 세부 정보를 설정하십시오.",
      "NOTE_TEXT": "SMTP를 사용하려면 먼저 IMAP을 구성하십시오.",
      "UPDATE": "IMAP 설정 업데이트",
      "TOGGLE_AVAILABILITY": "이 받은 메시지함에 대해 IMAP 구성 사용",
      "TOGGLE_HELP": "IMAP을 사용하면 이메일을 수신할 수 있습니다.",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP 설정이 성공적으로 업데이트되었습니다.",
        "ERROR_MESSAGE": "IMAP 설정을 업데이트할 수 없습니다."
      },
      "ADDRESS": {
        "LABEL": "주소",
        "PLACE_HOLDER": "주소 (예: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "포트",
        "PLACE_HOLDER": "포트"
      },
      "LOGIN": {
        "LABEL": "로그인",
        "PLACE_HOLDER": "로그인"
      },
      "PASSWORD": {
        "LABEL": "비밀번호",
        "PLACE_HOLDER": "비밀번호"
      },
      "ENABLE_SSL": "SSL 사용",
      "AUTH_MECHANISM": "인증"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Microsoft 계정을 재인증하십시오."
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "SMTP 세부 정보를 설정하십시오.",
      "UPDATE": "SMTP 설정 업데이트",
      "TOGGLE_AVAILABILITY": "이 받은 메시지함에 대해 SMTP 구성 사용",
      "TOGGLE_HELP": "SMTP를 사용하면 이메일을 발송할 수 있습니다.",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP 설정이 성공적으로 업데이트되었습니다.",
        "ERROR_MESSAGE": "SMTP 설정을 업데이트할 수 없습니다."
      },
      "ADDRESS": {
        "LABEL": "주소",
        "PLACE_HOLDER": "주소 (예: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "포트",
        "PLACE_HOLDER": "포트"
      },
      "LOGIN": {
        "LABEL": "로그인",
        "PLACE_HOLDER": "로그인"
      },
      "PASSWORD": {
        "LABEL": "비밀번호",
        "PLACE_HOLDER": "비밀번호"
      },
      "DOMAIN": {
        "LABEL": "도메인",
        "PLACE_HOLDER": "도메인"
      },
      "ENCRYPTION": "암호화",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL 인증 모드",
      "AUTH_MECHANISM": "인증"
    },
    "NOTE": "참고: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "웹사이트 아바타",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "아바타가 성공적으로 삭제되었습니다.",
              "ERROR_MESSAGE": "오류가 발생했습니다. 다시 시도하십시오."
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "웹사이트 이름",
          "PLACE_HOLDER": "웹사이트 이름 입력 (예: Acme Inc)",
          "ERROR": "올바른 웹사이트 이름을 입력하십시오."
        },
        "WELCOME_HEADING": {
          "LABEL": "환영 헤드라인",
          "PLACE_HOLDER": "안녕하세요!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "환영 태그라인",
          "PLACE_HOLDER": "우리는 간단하게 우리와 연결되도록 합니다. 우리에게 무엇이든 물어보거나 피드백을 공유하십시오."
        },
        "REPLY_TIME": {
          "LABEL": "응답 시간",
          "IN_A_FEW_MINUTES": "몇 분 후에",
          "IN_A_FEW_HOURS": "몇 시간 안에",
          "IN_A_DAY": "하루 안에"
        },
        "WIDGET_COLOR_LABEL": "위젯 색깔",
        "WIDGET_BUBBLE": "버블",
        "WIDGET_BUBBLE_POSITION_LABEL": "위젯 버블 위치",
        "WIDGET_BUBBLE_TYPE_LABEL": "위젯 버블 유형",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "채팅하기",
          "LABEL": "위젯 버블 런처 제목",
          "PLACE_HOLDER": "채팅하기"
        },
        "UPDATE": {
          "BUTTON_TEXT": "위젯 설정 업데이트",
          "API": {
            "SUCCESS_MESSAGE": "위젯 설정이 성공적으로 업데이트되었습니다.",
            "ERROR_MESSAGE": "위젯 설정을 업데이트할 수 없습니다."
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "미리보기",
          "SCRIPT": "스크립트"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "왼쪽",
          "RIGHT": "오른쪽"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "표준",
          "EXPANDED_BUBBLE": "확장 버블"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "기본",
        "CHAT": "채팅"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "보통 몇 분 안에 응답",
        "IN_A_FEW_HOURS": "보통 몇 시간 내에 응답",
        "IN_A_DAY": "보통 하루 안에 응답"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "대화 시작",
        "CHAT_INPUT_PLACEHOLDER": "메시지 입력"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "현재 온라인입니다",
          "OFFLINE": "현재 부재 중입니다"
        },
        "USER_MESSAGE": "안녕하세요",
        "AGENT_MESSAGE": "안녕하십니까"
      },
      "BRANDING_TEXT": "Chatwoot 작동중",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Microsoft에 연결"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Google에 연결"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "기타 공급자",
        "DESCRIPTION": "기타 공급자에 연결"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "웹사이트",
      "TWITTER_PROFILE": "트위터",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "이메일",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API 채널",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "음성"
    }
  }
}
